import axios from 'axios';
import services from '@/utils/services';
import { Notification } from 'element-ui';
import Cookies from 'js-cookie';

const TIMEOUT = 5000000;

/**
 * 通用ヘッダー構築（Content-Typeに応じて、token付きで返す）
 * @param {string} contentType - Content-Type
 * @returns {object} - ヘッダーオブジェクト
 */
function buildHeaders(contentType = 'application/json') {
  const customHeaders = {
    'Content-Type': contentType,
  };
  const token = Cookies.get('token');
  if (token) {
    customHeaders.token = token;
  }
  return customHeaders;
}

/**
 * 共通リクエスト処理
 * @param {object} params - リクエストパラメータ
 */
function axiosRequest(params = {}) {
  const headers = {
    ...(params.headers || buildHeaders('application/json'))
  };

  return new Promise((resolve, reject) => {
    axios({
      timeout: TIMEOUT,
      headers,
      ...params,
    }).then((res) => {
      if (res.status < 200 || res.status >= 300) {
        reject(res);
      } else {
        if (res.data.code === 0) {
          resolve(res.data.data);
          return;
        }
        Notification.closeAll();
        Notification({
          title: 'エラー',
          message: res.data.msg,
          duration: 0,
          offset: 75,
        });
        reject(res.data.msg || 'request failed');
        if (res.data.code === 401) {
          Cookies.remove('token');
        }
      }
    }).catch((error) => {
      Notification({
        title: 'エラー',
        message: error,
        duration: 0,
        offset: 75,
      });
      reject(error || 'request failed');
    });
  });
}

/**
 * 普通リクエスト定義（GET/POST）
 */
const normalRequest = {
  get: (url, params) => axiosRequest({
    method: 'get',
    url,
    params,
  }),
  post: (url, data) => axiosRequest({
    method: 'post',
    url,
    data,
  }),
};

/**
 * 外部統一インターフェース（FormDataアップロードも自動対応）
 * @param {string} serviceName - サービス名
 * @param {object} params - リクエストパラメータ
 */
const request = (serviceName, params) => {
  if (!services[serviceName]) {
    return Promise.reject(new Error('Request name is not defined'));
  }
  const {
    method = 'get',
    url = '',
  } = services[serviceName];
  const isFormData = typeof FormData !== 'undefined' && params instanceof FormData;
  if (isFormData && method === 'post') {
    const uploadHeaders = buildHeaders('multipart/form-data');
    return axiosRequest({
      method: 'post',
      url,
      data: params,
      headers: uploadHeaders,
    });
  }
  return normalRequest[method](url, params);
};

export default request;
